import {AtriumInfo, Customer, CustomerToken} from '../models/customer.model';

export const dataToCustomer = (data: any): Customer => {
  return new Customer(
    data.id,
    data.phone_number,
    data.reference_id,
    filterValidCards(data.cards),
    data.given_name,
    data.family_name,
    data.email_address,
    data.address,
    data.shared_cards,
    setLoyaltyPoints(data.loyalty_point_balance),
    data.square_loyalty_account_id,
    data.loyalty_program_reward_tiers,
    data.is_shared,
    data.gift_cards,
    data.ikon_pass_id,
  );
};

export const dataToCustomerToken = (data: any): CustomerToken => {
  return new CustomerToken(
    data.token,
    dataToCustomer(data.customer)
  );
};

export function setLoyaltyPoints(data): number {
  return data ? data : 0;
}

export function filterValidCards(cards: any[]): any[] {
  if (!Array.isArray(cards) || cards.length === 0) {
    return [];
  }
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear();

  const validCards = cards.filter(card => {
    const { exp_year, exp_month } = card;
    return (
      exp_year > currentYear ||
      (exp_year === currentYear && exp_month >= currentMonth)
    );
  });

  const uniqueCardsMap = new Map();

  validCards.forEach(card => {
    const key = `${card.card_brand}_${card.last4}`;

    if (uniqueCardsMap.has(key)) {
      const existingCard = uniqueCardsMap.get(key);
      if (
        card.exp_year > existingCard.exp_year ||
        (card.exp_year === existingCard.exp_year && card.exp_month > existingCard.exp_month)
      ) {
        uniqueCardsMap.set(key, card);
      }
    } else {
      uniqueCardsMap.set(key, card);
    }
  });

  return Array.from(uniqueCardsMap.values());
}

export const dataToAtriumInfo = (data: any): AtriumInfo => new AtriumInfo(
  data?.campus_id,
  data?.token,
  data?.balance,
  data?.currency
);
